import { useState } from 'react';

const faqs = [
  {
    question: 'Akü desteği hangi bölgelerde var?',
    answer:
      'Silivri merkezli olarak Silivri – Tekirdağ hattı ve çevre bölgeler için bilgi alabilirsiniz.',
  },
  {
    question: 'Yedek parça için ne göndermeliyim?',
    answer:
      'Araç marka, model, model yılı ve aradığınız parça bilgisini WhatsApp’tan göndermeniz yeterlidir.',
  },
  {
    question: 'Kargo gönderimi var mı?',
    answer:
      'Türkiye’nin 81 iline kargo gönderimi için WhatsApp’tan ürün uygunluğu sorabilirsiniz.',
  },
  {
    question: 'Fiyatı nasıl öğrenebilirim?',
    answer:
      'Araç ve parça bilgilerinizi göndererek hızlıca fiyat ve uygunluk bilgisi alabilirsiniz.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section id="sss" className="relative bg-brand-dark py-20 md:py-28">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
            Sık Sorulan Sorular
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                className="bg-brand-surface rounded-xl md:rounded-2xl border border-white/10 overflow-hidden"
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                >
                  <span className="text-white font-semibold text-sm md:text-base leading-snug">
                    {faq.question}
                  </span>
                  <span
                    className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-white/10 shrink-0 transition-transform duration-300 ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  >
                    <i className="fas fa-plus text-white text-xs"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-40' : 'max-h-0'
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-brand-muted text-sm md:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}